
/**
 * Module dependencies.
 */

import { uuid } from '../../regex';

/**
 * Export `payspaceRoutes`.
 */

export default {
  acceptInvitation: '/accept-invitation',
  confirmEmail: '/confirm-email',
  home: '/',
  payspaceNotActive: '/payspace-not-active',
  products: {
    base: '/products',
    details: `/products/:id(${uuid})`
  },
  resetPassword: '/reset-password',
  resetPasswordSuccess: '/reset-password-success',
  tasks: {
    details: `/tasks/:id(${uuid})`
  }
};
